import { useState, useEffect } from 'react'
import { Box, Container, Flex, Image, Heading, Text, Button } from "@chakra-ui/react"
import { CloseIcon } from '@chakra-ui/icons'
const ZoomImage = ({ url, onClose }) => {
	const [animStarted, setAnimStarted] = useState(false)

	useEffect(() => {
		setAnimStarted(true)
	}, [])
	return (
		<Box pos="fixed" top="0" left="0" zIndex="99999999999999999" height="100vh" w="100%" bg="rgba(0,0,0,0.6)">
			<Box
				h="100%"
				w="100%"
				bg="rgba(0,0,0,0.95)"
				opacity={animStarted ? 1 : '0.5'}
				transition='all 300ms ease'
				overflow="auto"
				display="flex"
				alignItems="center"
				justifyContent="center"
				flexDirection="column"
			>
				<CloseIcon
					pos="absolute"
					top="40px"
					right="50px"
					fontSize="50px"
					color="#fff"
					cursor="pointer"
					onClick={onClose}
				/>
				<Image src={url} w="auto" maxW="90%" h="auto" maxH="80%" mx="auto" />
			</Box>
		</Box>
	)
}

export default ZoomImage
